// Sort variants by price from high to low
function sortVariantsByPrice(variants) {
    return variants.sort((a, b) => b.price - a.price);
}

// Display price of another variant if price is zero
function displayPriceOfAnotherVariant() {
    document.querySelectorAll('.product').forEach(product => {
        const zeroPriceVariant = product.querySelector('.variant[data-price="0"]');
        if (zeroPriceVariant) {
            const otherVariants = Array.from(product.querySelectorAll('.variant:not([data-price="0"])'));
            const highestPriceVariant = sortVariantsByPrice(otherVariants)[0];
            const priceElement = zeroPriceVariant.querySelector('.price'); // Assuming the price is displayed inside an element with class 'price'
            if (priceElement && highestPriceVariant) {
                priceElement.textContent = highestPriceVariant.getAttribute('data-price');
            }
        }
    });
}

// Call function when the page is loaded
window.addEventListener('load', displayPriceOfAnotherVariant);